// ------------------------------------
// Constants
// ------------------------------------
export const PROFILE_ACCOUNT_GET_REQUEST = "PROFILE_ACCOUNT_GET_REQUEST";
export const PROFILE_ACCOUNT_GET_REQUEST_SUCCESS =
  "PROFILE_ACCOUNT_GET_REQUEST_SUCCESS";
export const PROFILE_ACCOUNT_GET_REQUEST_FAILURE =
  "PROFILE_ACCOUNT_GET_REQUEST_FAILURE";

// ------------------------------------
// Actions
// ------------------------------------
export function request() {
  return {
    type: PROFILE_ACCOUNT_GET_REQUEST,
  };
}

export function requestSuccess(res) {
  return {
    type: PROFILE_ACCOUNT_GET_REQUEST_SUCCESS,
    data: res,
  };
}

export function requestFailure(error) {
  return {
    type: PROFILE_ACCOUNT_GET_REQUEST_FAILURE,
    error,
  };
}
